<script lang="ts">
    import type {FlexibooksLoanability, LoanRequestOption} from 'src/typings';
    import {getInjector, getLocalization, getSanitize} from 'src/core';
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';
    import {LoanRequestFormService} from '../loan-request-form.service';
    import {strParams} from 'shared/utils/pipes';
    import {pipe} from 'core/utils';
    import LoginFirstButton from './shared/LoginFirstButton.svelte';
    import SendLoanRequestButton from './shared/SendLoanRequestButton.svelte';
    import OpenOnExternalLoanProviderWebsiteLink from './shared/OpenOnExternalLoanProviderWebsiteLink.svelte';
    import HelpDisclosure from './shared/HelpDisclosure.svelte';
    import LoanOptionPanelBody from './shared/LoanOptionPanelBody.svelte';

    export let option: LoanRequestOption<FlexibooksLoanability>;

    const localize = getLocalization();
    const sanitize = getSanitize();
    const service = getInjector().getByClass(LoanRequestFormService);

    $: showLoginButtonFirst = service.requiresLogin(option);
    $: requesterEmail = option.formObject.requester.email;
</script>

<KpGenericPanel>
    <strong slot="heading">
        {localize(/* @kp-localization loan.flexibooks.VypujcitDoCteckyPresFlexibooks */ 'loan.flexibooks.VypujcitDoCteckyPresFlexibooks')}
    </strong>

    <LoanOptionPanelBody>
        {#if !showLoginButtonFirst}
            <HelpDisclosure>
                <svelte:fragment slot="summary">
                    {localize(/* @kp-localization loan.flexibooks.JakPujcovat */ 'loan.flexibooks.JakPujcovat')}
                </svelte:fragment>
                <svelte:fragment slot="details">
                    <ol class="loan-request-list">
                        <li>{localize(/* @kp-localization loan.flexibooks.KlikneteNaVypujcit */ 'loan.flexibooks.KlikneteNaVypujcit')}</li>
                        <li>
                            {@html sanitize(
                                pipe(
                                    localize(/* @kp-localization loan.flexibooks.NaEmailXObdrzitePoukaz */ 'loan.flexibooks.NaEmailXObdrzitePoukaz'),
                                    strParams(`<strong>${requesterEmail}</strong>`))
                            )}
                        </li>
                    </ol>
                </svelte:fragment>
            </HelpDisclosure>
        {/if}

        <div>
            {localize(/* @kp-localization loan.ext.EVypujckaJeDostupnaProTatoZarizeni */ 'loan.ext.EVypujckaJeDostupnaProTatoZarizeni')}:
            <ul>
                <li>{localize(/* @kp-localization loan.ext.AnyOnlineDevice */ 'loan.ext.AnyOnlineDevice')}</li>
                <li>{localize(/* @kp-localization loan.ext.ZarizeniSWindows */ 'loan.ext.ZarizeniSWindows')}</li>
            </ul>
            <div>
                {localize(/* @kp-localization commons.viz */ 'commons.viz')}
                <a href="http://flexibooks.cz/jak-cist/" target="_blank">
                    http://flexibooks.cz/jak-cist
                </a>
            </div>
        </div>

        <div>
            {localize(/* @kp-localization loan.flexibooks.DodatecneInformace */ 'loan.flexibooks.DodatecneInformace')}
        </div>

        <OpenOnExternalLoanProviderWebsiteLink capability={option.capability}>
            {localize(/* @kp-localization loan.flexibooks.ZobrazitKnihuNaFlexibooks */ 'loan.flexibooks.ZobrazitKnihuNaFlexibooks')}
        </OpenOnExternalLoanProviderWebsiteLink>

        {#if showLoginButtonFirst}
            <LoginFirstButton/>
        {:else}
            <SendLoanRequestButton {option} apiPath="/loan-items/request/externalLendingRequest">
                {localize(/* @kp-localization loan.flexibooks.Vypujcit */ 'loan.flexibooks.Vypujcit')}
            </SendLoanRequestButton>
        {/if}
    </LoanOptionPanelBody>
</KpGenericPanel>